import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  token$ = this.authService.token$;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.token$.pipe(
      map((token) => {
        const rolesArray = token?.role.split(',');
        
        if (!rolesArray || rolesArray?.length === 0) return true;
       
        let permission = false;
        rolesArray?.forEach((role: string) => {
          if (this.hasRole(route, role)) permission = true;
        });

        if (!permission) this.router.navigate(['not-authorized']);

        return permission;
      })
    );
  }

  hasRole(
    component: ActivatedRouteSnapshot,
    role: string | undefined
  ): boolean {
    return component.data['roles'].find((r: string) => r === role) != null;
  }
}
